const addGroupsReducer = (state, action) => {
  if (action.status !== 'success') {
    return state;
  }

  const {
    payload: { groups, studentsWithNoGroup },
  } = action;

  const updatedGroups = {
    ...state.groups,
  };

  groups.forEach((group) => {
    updatedGroups[group.id] = group;
  });

  const setId = groups[0].set;
  const set = state.sets[setId];
  const updatedSet = { ...set, studentsWithNoGroup };

  groups.forEach(({ id }) => {
    if (!updatedSet.groups.includes(id)) {
      updatedSet.groups = [...updatedSet.groups, id];
    }
  });

  return {
    ...state,
    groups: updatedGroups,
    sets: {
      ...state.sets,
      [setId]: updatedSet,
    },
  };
};

export default addGroupsReducer;
